export const BASKET_COLUMN_ID_USER_IMAGE = "cc080d73-88f4-4bfc-8ec1-e7e2ad30739a";
export const BASKET_COLUMN_ID_EXT_ITEM_NUMBER = "c962203c-7e83-4a2f-8060-acaa4a06c921";
export const BASKET_COLUMN_ID_COMMENTS = "c0a44351-9974-4708-a344-90cafc3a42cd";
export const BASKET_COLUMN_ID_ADDITIONAL_IMAGES = [
    "7423b6f0-d424-48b3-b75c-9fc5c61992c1",
    "a3cc0a92-9b7c-4d51-a893-796a5adca350",
    "85d7d0a1-6fe6-4c83-ac6d-3c225038f325",
    "66dce599-d33f-481b-94aa-1caac4cd1a4a",
    "070a5251-d7c4-4ada-a086-06c1a625d215",
    "43ad12e0-f290-4290-9968-5efb466d8939",
    "6d5c4f9f-e560-4601-a254-94c10e5b9ed5",
    "35e71612-ecba-4d52-b2d0-55cee65748ba",
    "93f7b14b-7379-4b58-a620-0562abba35a6",
    "e39c215c-c463-4ca8-8e59-cc63f6c1538b"
];
export const MAX_CONCURRENT_ARTICLE_UPDATES = 5;
export const MAX_CONCURRENT_TASKS = 10;
